import React from 'react';
import DashboardLayout from './layout/dashboardLayout';
import UserTransactionsList from '../components/WalletHistoryList/usersTransactionsList';

const Transactions = (props) => {
    return (
        <DashboardLayout>
            <UserTransactionsList />
        </DashboardLayout>
    )
};
export default Transactions;